
















import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

interface Style {
  backgroundColor: string;
  backgroundImage: string;
  opacity: number;
}

@Component
export default class VButton extends Vue {
  @Prop() onClick!: Function
  @Prop() color!: string
  @Prop() loading!: boolean
  @Prop() disabled!: boolean

  private id = 0

  style: Style = {
    backgroundColor: ' #dd7373',
    backgroundImage: 'none',
    opacity: 1
  }

  @Watch('disabled')
  onDisabled (val: boolean) {
    this.style.opacity = val ? 0.6 : 1
  }

  mounted () {
    this.id = Math.round(Math.random() * 10000)
    if (this.disabled) this.style.opacity = 0.6
    if (this.color === 'primary') this.style.backgroundColor = '#dd7373'
    else if (this.color === 'secondary') this.style.backgroundColor = '#312c50'
    else this.style.backgroundColor = this.color
  }

  animateAndRun (event: MouseEvent) {
    if (this.disabled) return
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    const rect = event.target.getBoundingClientRect()
    const x = event.x - rect.left
    const y = event.y - rect.top

    const duration = 700
    let animationFrame: number
    let animationStart: number

    const animationStep = (timestamp: number) => {
      if (!animationStart) {
        animationStart = timestamp
      }

      const frame = timestamp - animationStart

      if (frame < duration) {
        const easing = (frame / duration) * (2 - (frame / duration))

        const circle = 'circle at ' + x + 'px ' + y + 'px'
        const color = 'rgba(0, 0, 0, ' + (0.3 * (1 - easing)) + ')'
        const stop = 90 * easing + '%'
        this.style.backgroundImage = 'radial-gradient(' + circle + ', ' + color + ' ' + stop + ', transparent ' + stop + ')'

        animationFrame = window.requestAnimationFrame(animationStep)
      } else {
        this.style.backgroundImage = 'none'
        window.cancelAnimationFrame(animationFrame)
      }
    }
    animationFrame = window.requestAnimationFrame(animationStep)
    if (this.onClick) setTimeout(this.onClick, 200)
  }
}
